import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/AddCompanyFoldersWizard.scss';
import autobind from 'autobind-decorator';
import { __, mapStateToProps, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import { withRouter } from 'react-router';
import * as _ from 'lodash';
import Localization from '../helpers/Localization';
import { subscribe } from 'react-contextual';
// import {
//   createCompanyFolder,
//   listCompanyFolders,
// } from '../redux/actions/table/company_folders';
import AddCompanyIcon from '../assets/images/add-company-60x60.svg';
import AddCompanyFoldersForm from '../forms/add_company_folders_wizard/AddCompanyFoldersForm';
import {
  createCompanyFolder,
  listCompanyFolders,
} from '../redux/actions/table/company_folders';

@withRouter
@mapStateToProps((state) => ({
  table: state.table['company_folders'],
  auth: state.auth,
}))
@subscribe(Localization, 'localization')
class AddCompanyFoldersWizard extends Component {
  @autobind
  _handleSubmit(formData) {
    const company_id = this.props.auth.company.id;

    return validateForm(
      createCompanyFolder(formData).then(({ response }) => {
        listCompanyFolders();
        setNotification(__('wizard.add-company-folder.confirm'));
        this.props.onClose();
      })
    );
  }

  render() {
    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>{__('wizard.add-company-folders.title.create-new')}</span>
            <span>{__('wizard.add-company-folders.subtitle.create-new')}</span>
          </div>
          <div className={styles.right}>
            <AddCompanyIcon />
          </div>
        </div>
        <div className={styles.body}>
          <AddCompanyFoldersForm onSubmit={this._handleSubmit} />
        </div>
      </>
    );
  }
}

export default AddCompanyFoldersWizard;
